import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Area } from '../state-man/models/area.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class AreaService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  public async getAll () : Promise<Area[] | null> {      
    try {
      const ret = await this.apiService.apiReturnsAny('get', 'area/active/')            
      return (ret && Array.isArray(ret)) ? Area.buildMany(ret) : null
    } 
    catch (error) {      
      LoggerService.log(error + 'area/active')    
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }
  }  
  
}
